import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import styles from "./illustrationGame.module.css";
import ImgBuilder from "../../assets/ImgBuilder";
import { useNavigate } from "react-router-dom";
import story from "./story/illustrationGame.json";
import { useLanguage } from '../../functions/setGetLanguage';
import PopupWithImage from "../../components/popupWithImage/popupWithImage";
import { renderWithLineBreaksAndBold } from '../../functions/renderWithLineBreaksAndBold';

const IllustrationGame = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [popupShow, setPopupShow] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [current, setCurrent] = useState("start");
  const { language } = useLanguage();

  useEffect(() => {
    const firstNode = story.find((item) => item.id === "start");
    console.log(firstNode);
    if (!firstNode) return;

    setCurrent(firstNode);
    setIsLoaded(true);
  }, []);

  useEffect(() => {
    if (popupShow) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
  }, [popupShow]);

  const handleChoice = (choice) => {
    const last_img = current.asset
    const currentNode = story.find((item) => item.id === choice.next);
    if (!currentNode){
      navigate('/');
    }
    else{
      setCurrent(currentNode);
      if (!(last_img === currentNode.asset)){
        setImageLoaded(false);
      }
    }
  }

  return (
    <div className={styles.wrapperLogin}>
      {popupShow &&
        <PopupWithImage
          name={t("pop_up_notifications.abort_name")}
          description={t("pop_up_notifications.abort_description")}
          button={t("pop_up_notifications.button_terminate")}
          button_exit={t("pop_up_notifications.button_cancel")}
          type={"confirmation"}
          defExit={() => setPopupShow(false)}
          defContinue={() => navigate("/")}
        />
      }
      <img alt="bg" className={styles.bgImg} src={ImgBuilder.sbBackground}/>

        {isLoaded &&
          <div className={styles.storyContainer}>
            <div className={styles.upperMenu}>
              <div className={styles.buttonMenu} onClick={() => setPopupShow(true)}>

              </div>
            </div>
            <div className={styles.illustrationContainer}>
              {!imageLoaded && <div className={styles.loader}></div>}
              <img 
                // key={ImgBuilder[current.asset]} // to unmount an image
                style={{
                opacity: isLoaded ? 1 : 0,
                  transition: "opacity 0.6s ease-in-out",
                }}
                onLoad={() => setImageLoaded(true)}
                alt="illustration" className={styles.illustrationImage} 
                src={ImgBuilder[current.asset]}
               />
            </div>
            <div className={styles.explanationContainer}>
              <div className={styles.explanation}>
                {current[`text${language}`]}
              </div>
            </div>
            <div className={styles.buttonsContainer}> 
              {current.choices.map((msg, idx) =>
                <div onClick={() => handleChoice(msg)} key={idx} className={styles.button}>
                  {renderWithLineBreaksAndBold(msg[`text${language}`])}
                </div>
              )}
            </div>
          </div>
        }

    </div>
  );
};

export default IllustrationGame;
